import { Icon } from "@wordpress/components";
import { download } from "@wordpress/icons";
import { useEffect, useState } from "react";

const DownloadProgress = ({
  iconSize = 24,
  fillColor = 'white',
  text = 'Downloading...',
  textColor = 'white',
  progressValue = 50,
  barBackgroundColor = 'grey',
  barFillColor = 'white',
  barHeight = '3px',
  barRadius = '5px',
}) => {

  return (
    <>
      <Icon size={iconSize} fill={fillColor} icon={download} />
      <div
      key="loader-container"
        style={{
          color: textColor,
          marginTop: '10px',
          lineHeight: '100%',
          transition: 'color 0.3s ease'
        }}
      >
        {text}
      </div>
      <progress
        value={progressValue}
        max="100"
        style={{
          marginTop: '20px',
          width: '80%',
          height: barHeight,
          borderRadius: barRadius,
          backgroundColor: barBackgroundColor,
          transition: 'background-color 0.3s ease, height 0.3s ease'
        }}
      ></progress>
      {/* <div
        key="loader-bar"
        style={{
          marginTop: '20px',
          width: '80%',
          backgroundColor: barBackgroundColor,
          height: barHeight,
          borderRadius: barRadius,
          transition: 'background-color 0.3s ease, height 0.3s ease'
        }}
      >
        <div
          key="loader-progress"
          style={{
            transition:"all 0.03 linear",
            width: `${displayedProgress}%`,
            backgroundColor: barFillColor,
            height: '100%',
            borderRadius: barRadius,
          }}
        ></div>
      </div> */}
    </>
  );
};

export default DownloadProgress;